import { computed, inject, Service } from '@angular/core'

import { AuthService } from '@core/auth'

@Service()
export class AppStore {
  #authService = inject(AuthService)

  readonly currentUser = computed(() => this.#authService.currentUser())
  readonly isAuthenticated = computed(() => this.#authService.isAuthenticated())

  async updateUser(data: Record<string, unknown>): Promise<void> {
    await this.#authService.updateCurrentUser(data)
    await this.#authService.loadCurrentUser()
  }

  async reloadUser(): Promise<void> {
    await this.#authService.loadCurrentUser()
  }

  logout(): Promise<void> {
    return this.#authService.logout()
  }
}
